import React, { useEffect, useState } from 'react';
import { UserPlus, Check, X } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import { CHARACTERS } from '../lib/levels';

export default function ParentBuddyRequests() {
  const [requests, setRequests] = useState([]);
  const [busyId, setBusyId] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get('/parent/buddy-requests');
      setRequests(data.requests || []);
    } catch { /* silent */ }
    finally { setLoaded(true); }
  };
  useEffect(() => { load(); }, []);

  const act = async (id, approve) => {
    setBusyId(id);
    try {
      await api.post(`/parent/buddy-requests/${id}/${approve ? 'approve' : 'deny'}`);
      toast.success(approve ? 'Buddy approved 🎉' : 'Request denied');
      await load();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Failed'); }
    finally { setBusyId(null); }
  };

  if (!loaded || requests.length === 0) return null;

  return (
    <section className="bg-white rounded-3xl p-5 shadow-squishy border-4 border-gold" data-testid="parent-buddy-requests">
      <div className="flex items-center gap-2 mb-3">
        <UserPlus className="w-5 h-5 text-gold" />
        <span className="text-gold font-heading font-bold text-[11px] uppercase tracking-wider">Buddy Approval Needed</span>
        <span className="ml-auto text-navy/60 text-xs font-bold">{requests.length} pending</span>
      </div>
      <div className="space-y-3">
        {requests.map((r) => {
          const myChar = CHARACTERS[r.my_child_character] || CHARACTERS.ouistiti;
          const buddyChar = CHARACTERS[r.buddy_character] || CHARACTERS.ouistiti;
          return (
            <div key={r.id} className="rounded-2xl bg-cream p-3 space-y-3" data-testid={`buddy-request-${r.id}`}>
              <div className="flex items-center gap-2 justify-center">
                <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-teal">
                  <img src={myChar.image} alt="" className="w-full h-full object-cover" />
                </div>
                <div className="font-heading font-bold text-navy text-sm">{r.my_child_name}</div>
                <span className="text-teal font-heading font-bold text-2xl">↔</span>
                <div className="font-heading font-bold text-navy text-sm">{r.buddy_name}</div>
                <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-gold">
                  <img src={buddyChar.image} alt="" className="w-full h-full object-cover" />
                </div>
              </div>
              <p className="text-navy/70 text-xs text-center">
                <span className="font-bold">{r.my_child_name}</span> wants to add <span className="font-bold">{r.buddy_name}</span> as a buddy. Buddies can send emoji high-fives — no direct messages.
              </p>
              <div className="grid grid-cols-2 gap-2">
                <button onClick={() => act(r.id, false)} disabled={busyId === r.id}
                  className="h-11 rounded-full bg-white text-navy border-2 border-slate-200 font-heading font-bold text-sm inline-flex items-center justify-center gap-1 hover:border-red-400 hover:text-red-500 disabled:opacity-60"
                  data-testid={`deny-buddy-${r.id}`}>
                  <X className="w-4 h-4" /> Deny
                </button>
                <button onClick={() => act(r.id, true)} disabled={busyId === r.id}
                  className="h-11 rounded-full bg-gold text-navy font-heading font-bold text-sm inline-flex items-center justify-center gap-1 shadow-gold disabled:opacity-60"
                  data-testid={`approve-buddy-${r.id}`}>
                  <Check className="w-4 h-4" /> Approve
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
